import { render, staticRenderFns } from "./AzureKvIcon.vue?vue&type=template&id=cf84d1ea"
import script from "./AzureKvIcon.vue?vue&type=script&lang=js"
export * from "./AzureKvIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports